import { EstateSubType, EstateType, ProjectType } from '@aviv-search/types';
// Frecn targeting oriented enum to map legacy estate types (in french, type de bien or idtb)
export var EstateTypeLegacyId;
(function (EstateTypeLegacyId) {
    EstateTypeLegacyId[EstateTypeLegacyId["APPARTMENT"] = 1] = "APPARTMENT";
    EstateTypeLegacyId[EstateTypeLegacyId["HOUSE"] = 2] = "HOUSE";
    EstateTypeLegacyId[EstateTypeLegacyId["PARKING"] = 3] = "PARKING";
    EstateTypeLegacyId[EstateTypeLegacyId["PLOT"] = 4] = "PLOT";
    EstateTypeLegacyId[EstateTypeLegacyId["TRADING"] = 5] = "TRADING";
    EstateTypeLegacyId[EstateTypeLegacyId["BUSINESS"] = 6] = "BUSINESS";
    // NA Locaux_Act_Entreprots = 7,
    EstateTypeLegacyId[EstateTypeLegacyId["OFFICE"] = 8] = "OFFICE";
    EstateTypeLegacyId[EstateTypeLegacyId["LOFT"] = 9] = "LOFT";
    EstateTypeLegacyId[EstateTypeLegacyId["MISC"] = 10] = "MISC";
    // NA Immeuble = 11,
    // NA Bâtiment = 12,
    EstateTypeLegacyId[EstateTypeLegacyId["CASTLE"] = 13] = "CASTLE";
    EstateTypeLegacyId[EstateTypeLegacyId["MANOR_HOUSE"] = 14] = "MANOR_HOUSE";
    EstateTypeLegacyId[EstateTypeLegacyId["COWORKING"] = 15] = "COWORKING";
    // NA Immobilier_Entreprise = 16,
    // NA Maisons_Terrains = 17,
    EstateTypeLegacyId[EstateTypeLegacyId["SINGLE_FAMILY_HOUSE"] = 20] = "SINGLE_FAMILY_HOUSE";
    EstateTypeLegacyId[EstateTypeLegacyId["CHALET"] = 21] = "CHALET";
    EstateTypeLegacyId[EstateTypeLegacyId["COUNTRY_HOUSE"] = 22] = "COUNTRY_HOUSE";
    // NA Bateau = 23,
    EstateTypeLegacyId[EstateTypeLegacyId["WINERY_OR_RIDING"] = 24] = "WINERY_OR_RIDING";
    EstateTypeLegacyId[EstateTypeLegacyId["PROJECT"] = 25] = "PROJECT";
})(EstateTypeLegacyId || (EstateTypeLegacyId = {}));
const estateTypesRecord = {
    Apartment: EstateTypeLegacyId.APPARTMENT,
    Miscellaneous: EstateTypeLegacyId.MISC,
    Parking: EstateTypeLegacyId.PARKING,
    Plot: EstateTypeLegacyId.PLOT,
    Trading: EstateTypeLegacyId.TRADING,
    Office: EstateTypeLegacyId.OFFICE,
};
const defaultLegacyTypes = [EstateTypeLegacyId.HOUSE];
export const getLegacyEstateTypes = (searchModel) => {
    if (!searchModel?.estateTypes)
        return defaultLegacyTypes;
    if (searchModel?.projectTypes?.includes(ProjectType.NEW_BUILD))
        return [EstateTypeLegacyId.PROJECT];
    const { estateTypes = [], estateSubTypes: subtypes = [] } = searchModel;
    // Specific House/Appartment case
    if (estateTypes.includes(EstateType.APARTMENT) && estateTypes.includes(EstateType.HOUSE)) {
        return [EstateTypeLegacyId.HOUSE, EstateTypeLegacyId.APPARTMENT];
    }
    const estateType = estateTypes[0] ?? EstateType.HOUSE;
    const directMatch = estateTypesRecord[estateType];
    if (directMatch)
        return [directMatch];
    // Specific cases
    if (estateType === EstateType.AGRICULTURE_FORESTRY &&
        (subtypes.includes(EstateSubType.WINERY) || subtypes.includes(EstateSubType.RIDING))) {
        return [EstateTypeLegacyId.WINERY_OR_RIDING];
    }
    if (subtypes.includes(EstateSubType.LOFT))
        return [EstateTypeLegacyId.LOFT];
    if (subtypes.includes(EstateSubType.CASTLE))
        return [EstateTypeLegacyId.CASTLE];
    if (subtypes.includes(EstateSubType.MANOR_HOUSE))
        return [EstateTypeLegacyId.MANOR_HOUSE];
    if (subtypes.includes(EstateSubType.COWORKING))
        return [EstateTypeLegacyId.COWORKING];
    if (subtypes.includes(EstateSubType.SINGLE_FAMILY_HOUSE))
        return [EstateTypeLegacyId.SINGLE_FAMILY_HOUSE];
    if (subtypes.includes(EstateSubType.CHALET))
        return [EstateTypeLegacyId.CHALET];
    if (subtypes.includes(EstateSubType.RUSTICO))
        return [EstateTypeLegacyId.COUNTRY_HOUSE];
    return defaultLegacyTypes;
};
